import styled from "styled-components";

export const TrendingParent = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #Fafbfc;
    & h1{
        margin-left: 1rem;
    }
`;

export const ImageContainer = styled.div`
width: 100%;
height: 50%;
display: flex;
background: #Fafbfc;
justify-content: space-around;
align-content: stretch;
align-items: center;
font-size: 1.2rem; 
margin-top:2rem;      
`;

export const ImgContainer = styled.div`
width: 100%;
height: 100%;
display: flex;
background: #Fafbfc;
justify-content: space-around;
align-content: stretch;
align-items: center;
font-size: 1.2rem;
margin-top: 2rem;       
`;